import { MINIMUM_PASSWORD_LENGTH } from './constants'

export function hasLowerCaseLetter(password: string) {
  return /[a-z]/.test(password)
}

export function hasUpperCaseLetter(password: string) {
  return /[A-Z]/.test(password)
}

export function hasMixedCase(password: string) {
  return hasLowerCaseLetter(password) && hasUpperCaseLetter(password)
}

export function hasSpecialChar(password: string) {
  const specialChars = [
    '!',
    '@',
    '#',
    '$',
    '%',
    '^',
    '&',
    '*',
    '(',
    ')',
    '-',
    '_',
    '=',
    '+',
    '[',
    ']',
    '\\',
    '/',
    '.',
    ',',
    '{',
    '}',
    '|',
    ':',
    ';',
    '<',
    '>',
    '?',
    '~',
  ]

  for (const specialChar of specialChars) {
    if (password.includes(specialChar)) {
      return true
    }
  }

  return false
}

export function hasMinimumCharacters(password: string) {
  return password.length >= MINIMUM_PASSWORD_LENGTH
}

export function hasNumber(password: string) {
  return /\d/.test(password)
}

export function hasNoSpaces(password: string) {
  return !/\s/.test(password)
}
